/* eslint-disable no-param-reassign */
import { createAction } from '@reduxjs/toolkit';

import { deselectAll } from './helpers/applySelection';

export const deselectAllProducts = createAction('products/deselectAllProducts');

export const reducer = (builder) => {
  builder
    .addCase(deselectAllProducts, (state) => {
      state.ui.selection = deselectAll();
      state.ui.selectionFeedback = null;
      state.ui.isSelectingAll = false;
      state.ui.selectAllRequestId = null;
    });
};
